import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState } from 'react';
import styled from 'styled-components';
import DSButton from '@elliemae/ds-basic/Button';
import MoreOptionsVert from '@elliemae/ds-icons/MoreOptionsVert';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ToolbarBtns = /*#__PURE__*/styled.div.withConfig({
  componentId: "pm75g5-0"
})(["& > .em-ds-toolbar{box-shadow:none;}"]);
var ToolbarWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "pm75g5-1"
})(["display:flex;align-items:center;height:", ";margin-left:-4px;margin-right:", ";padding-right:4px;pointer-events:all;background:white;", " &:hover{box-shadow:-1px 0px 1px 0px rgba(0,0,0,0.2),1px 0px 2px 0px rgba(0,0,0,0.2);& > .toolbar-trigger{border:none;}}"], function (props) {
  return props.rowSize === 'normal' ? '36px' : '28px';
}, function (props) {
  return props.hasScrollBar ? '0' : '-10px';
}, function (props) {
  return props.showShadow ? "box-shadow: -1px 0px 1px 0px rgba(0, 0, 0, 0.2),\n  1px 0px 2px 0px rgba(0, 0, 0, 0.2);" : '';
});
var ToolbarPosition = /*#__PURE__*/styled.div.withConfig({
  componentId: "pm75g5-2"
})(["position:absolute;z-index:10;display:flex;justify-content:flex-end;align-items:center;width:0;pointer-events:none;top:0;height:", ";margin-top:", ";"], function (props) {
  return props.rowRef.current ? "".concat(props.rowRef.current.offsetHeight, "px") : '36px';
}, function (props) {
  return props.rowSize === 'normal' ? '0' : '0';
}); // eslint-disable-next-line react/prop-types

var ToolbarTrigger = function ToolbarTrigger(_ref) {
  var grid = _ref.grid,
      rowData = _ref.rowData,
      hasScrollBar = _ref.hasScrollBar,
      rowRef = _ref.rowRef;

  var _grid$getInstance = grid.getInstance(),
      _grid$getInstance$pro = _grid$getInstance.props,
      renderToolbar = _grid$getInstance$pro.renderToolbar,
      rowSize = _grid$getInstance$pro.rowSize;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];
  /* eslint-disable indent */


  var toolbar = show ? renderToolbar(_objectSpread(_objectSpread({}, rowData), {}, {
    size: rowSize,
    isToolbarShown: show,
    setToolbarShow: setShow
  })) : null;
  /* eslint-enable indent */

  return /*#__PURE__*/React.createElement(ToolbarPosition, {
    rowSize: rowSize,
    rowRef: rowRef
  }, /*#__PURE__*/React.createElement(ToolbarWrapper, {
    onMouseEnter: function onMouseEnter() {
      return setShow(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShow(false);
    },
    showShadow: show,
    rowSize: rowSize,
    hasScrollBar: hasScrollBar
  }, show && /*#__PURE__*/React.createElement(ToolbarBtns, null, toolbar), /*#__PURE__*/React.createElement(DSButton, {
    buttonType: "text",
    className: "toolbar-trigger",
    "data-testid": "toolbar-trigger",
    icon: /*#__PURE__*/React.createElement(MoreOptionsVert, null) // eslint-disable-next-line react/prop-types
    ,
    index: rowData.index,
    onClick: function onClick() {
      return setShow(true);
    },
    tabIndex: -1
  })));
};

export default ToolbarTrigger;
export { ToolbarTrigger };
//# sourceMappingURL=ToolbarTrigger.js.map
